module.exports = __webpack_public_path__ + "static/media/gmail.a4ada17f.png";